import axios from "axios";
import { base_url, config } from "../../utils/axiosConfig";

// Get all courses
const getCourses = async () => {
  const response = await axios.get(`${base_url}course`, config);
  if (response.data) {
    return response.data;
  }
};

// Get a single course by ID
const getCourse = async (id) => {
  const response = await axios.get(`${base_url}course/${id}`, config);
  if (response.data) {
    return response.data;
  }
};

export const courseService = {
  getCourses,
  getCourse,
};
